export default __webpack_public_path__ + "media/images/react_icons/comment-bea43f825dcd8c39979b7f5c33a38d34.svg";